/* eslint-disable import/prefer-default-export */
import { RootState } from "../reducers"

export const selectLatestBridgeTransactions = (state: RootState) =>
  state.bridge.latestTransactions
